import { DeleteOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Col, Form, Input, Modal, Popconfirm, Row, Skeleton, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import Table from "../../../../contents/AntTableResponsive";


export default function FeeSubHead(props) {

    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();

    const feeSubHeadList = useStoreState((state) => state.saccount.feeSubHeadList);
    const fetchfeesubHeadList = useStoreActions((state) => state.saccount.fetchfeesubHeadList);
    const createFeeSubHead = useStoreActions((state) => state.saccount.createFeeSubHead);
    const updateFeeSubHead = useStoreActions((state) => state.saccount.updateFeeSubHead);
    const deleteFeeSubHead = useStoreActions((state) => state.saccount.deleteFeeSubHead);
    const loading = useStoreState((state) =>  state.saccount.loading);

    useEffect(() => {
        fetchfeesubHeadList();
    }, [])

    const formSubmit = (value) => {
        value.status = 1;
        createFeeSubHead(value);
        form.resetFields();
    }

    const updateFomrSubmit = (value) => {
        let postdata = {
            id: id,
            name: value.name,
            serial: value.serial,
            status: value.status === true ? 1 : 0
        }
        updateFeeSubHead(postdata);
        setIsModalVisible(false);
    }

    const [id, setId] = useState<any>();

    const columns = [

        {
            title: 'Serial',
            dataIndex: 'serial',
            key: 'serial',
            showOnResponse: true,
            showOnDesktop: true
        },
        {
            title: 'Fee Subhead Name',
            dataIndex: 'name',
            key: 'name',
            showOnResponse: true,
            showOnDesktop: true
        },
        {
            title: 'Status',
            key: 'status',
            showOnResponse: true,
            showOnDesktop: true,
            render: (text: any, record: any, index) => (
                <span>{record?.status === 1 ? "Enabled" : "Disabled"}</span>
            ),
        },
        {
            title: 'Action',
            key: 'ledgerId',
            showOnResponse: true,
            showOnDesktop: true,
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    <Tooltip title="Edit">
                        <Button type='primary' icon={<EditOutlined />} onClick={() => {
                            setIsModalVisible(true);
                            setId(record.id);
                            updateForm.setFieldsValue({
                                name: record.name,
                                status: record.status === 1 ? true : false,
                                serial: record.serial,
                            });
                        }}
                        />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => deleteFeeSubHead(record?.id)}
                    >
                        <Tooltip title="Delete">
                            <Button danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const [isModalVisible, setIsModalVisible] = useState(false);

    return (
        <>
            <Card title="Fee Sub Head" >
                <Form
                    layout="vertical"
                    onFinish={formSubmit}
                    id="basic-info"
                    form={form}
                >
                    <Row gutter={8}>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}> </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Form.Item
                                name="name"
                                label="Fee Subhead Name"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please input Fee Subhead name" },
                                ]}
                            >

                                <Input placeholder="Fee Subhead" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Form.Item
                                name="serial"
                                label="Serial"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please input serial" },
                                ]}
                            >

                                <Input placeholder="Serial" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                            <Space size="small" >
                                <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SaveOutlined />}>
                                    Save
                                </Button>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={4} xl={4}> </Col>
                    </Row>
                </Form>
               {feeSubHeadList=== null && < Skeleton loading={loading} paragraph={{rows:10}} />}                   
               {feeSubHeadList!== null &&
                <div className="datatable-responsive">
                    {/* <Table bordered={true} ledgerList={ledgerList} columns={columns} className="p-datatable-responsive-demo" /> */}

                    <Table
                        antTableProps={{
                            showHeader: true,
                            columns,
                            dataSource: feeSubHeadList,
                            filterData: feeSubHeadList,
                            // pagination: false,
                            bordered: true
                        }}
                        mobileBreakPoint={768}
                    />
                </div>
}
            </Card>

            <Modal
                title="Update Fee Subhead"
                visible={isModalVisible}
                //  onOk={handleOk}
                okButtonProps={{ form: 'update', htmlType: 'submit' }}
                onCancel={() => setIsModalVisible(false)}
                cancelText="Close"
                okText="Update"
                centered
            >
                <Form
                    layout="vertical"

                    onFinish={updateFomrSubmit}
                    id="update"
                    form={updateForm}
                >

                    <Form.Item
                        name="name"
                        label="Fee Subhead Name:"
                        className="title-Text"
                        rules={[
                            { required: true, message: "Please input Fee Subhead name" },
                        ]}
                    >
                        <Input placeholder='Fee Subhead Name' />
                    </Form.Item>


                    <Form.Item
                        name="serial"
                        label="Serial:"
                        className="title-Text"
                        rules={[
                            { required: true, message: "Please input serial" },
                        ]}
                    >
                        <Input placeholder='Note' />
                    </Form.Item>

                    <Form.Item
                        name="status"
                        label="Status:"
                        valuePropName="checked"
                        className="title-Text"
                        rules={[
                            { required: true, message: "Please input serial" },
                        ]}
                    >
                        <Checkbox >Status</Checkbox>
                    </Form.Item>
                </Form>

            </Modal>
        </>
    )
}
